<!--
 * A Vue component for showing terms
-->
<template>
    <div>
        <a v-if="hasMapTerms" @click="$_showMapTerms" class="footer-link">{{ $t('mapDataLink') }}</a>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters(['getMapTerms']),

            mapTerms() {
                return this.getMapTerms();
            },

            /*
             * Determines whether to show the map terms link
             */
            hasMapTerms() {
                return this.mapTerms.length > 0;
            }
        },

        methods: {
            /*
             * Shows a toaster, containing the claims of all loaded and in range themelayers
             */
            $_showMapTerms() {
                this.$store.commit('ADD_STATUS_MESSAGE', {
                    title: this.$t('mapDataLink'),
                    message: this.mapTerms.join('\n'),
                    variant: 'info',
                    autoHideDelay: 5000,
                });
            }
        }
    };
</script>

<style scoped>
    .footer-link {
        margin-left: 3px;
    }
</style>
